export const START = '[timer] start';
export const STOP = '[timer] stop';
export const RESET = '[timer] reset';
